// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-bAM_"};